import CONSTANTS from '@/constants'

const { BLACK_FRIDAY_PRODUCT_BUNDLES, LEAP_YEAR_PROMO_PRODUCT_BUNDLES } = CONSTANTS
const { INE_BLACK_FRIDAY_BUNDLE_ONE, INE_BLACK_FRIDAY_BUNDLE_TWO, INE_BLACK_FRIDAY_BUNDLE_THREE } =
  BLACK_FRIDAY_PRODUCT_BUNDLES
const { INE_LEAP_YEAR_BUNDLE } = LEAP_YEAR_PROMO_PRODUCT_BUNDLES

export const availableProductBundlesHydratation = productBundlesCollection => {
  const renewalMessageOpt2 =
    'Your INE subscription will automatically renew at standard stated pricing at end of each subscription term unless you cancel your renewal prior to the end of said term. You must cancel your subscription renewal before the scheduled renewal date to avoid auto renewal and the associated renewal fee.'
  productBundlesCollection.forEach(boundle => {
    boundle.merchant_id = boundle.slug
    switch (boundle.slug) {
      case INE_BLACK_FRIDAY_BUNDLE_ONE:
        boundle.nameToShow = 'Premium + Skill Dive + 1 INE Security Certification'
        boundle.renewalMessage =
          'Each INE subscription will automatically renew at standard stated pricing at end of each subscription term unless you cancel your renewal prior to the end of said term. You must cancel your subscription renewal before the scheduled renewal date to avoid auto renewal and the associated renewal fee.'
        break
      case INE_BLACK_FRIDAY_BUNDLE_TWO:
        boundle.nameToShow = 'Premium + 1 INE Security Certification'
        boundle.renewalMessage = renewalMessageOpt2
        break
      case INE_BLACK_FRIDAY_BUNDLE_THREE:
        boundle.nameToShow = 'Fundamentals Annual'
        boundle.renewalMessage = renewalMessageOpt2
        break
      case INE_LEAP_YEAR_BUNDLE:
        boundle.nameToShow = 'Premium + 1 INE Security Certification'
        boundle.renewalMessage = renewalMessageOpt2
        break
      default:
        break
    }
  })
}
